import React, { useRef } from 'react';
import { Tooltip } from 'acud';
import cx from 'classnames';
import { getEnv } from '../../utils/getEnv.js';
import 'tslib';
import BdAICloud from './assets/icons/BdAICloud.js';

var env = getEnv();
function Capsule(props) {
  var isMobile = props.isMobile,
    _a = props.env,
    _env = _a === void 0 ? env : _a;
  var capsuleRef = useRef(null);
  var capsuleMobileRef = useRef(null);
  // 点击智能云官网按钮
  var handleCloudAddressClick = function handleCloudAddressClick() {
    var url = _env === 'SANDBOX' ? 'https://cloudtest.baidu.com' : 'https://cloud.baidu.com';
    window.open(url, '_blank');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: 'capsule-root',
    id: "capsule"
  }, !isMobile && (/*#__PURE__*/React.createElement("div", {
    className: cx('capsule bright-capsule'),
    ref: capsuleRef
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottomRight",
    trigger: "hover",
    zIndex: 99999,
    getPopupContainer: function getPopupContainer() {
      return capsuleRef.current;
    },
    title: "\u524D\u5F80\u667A\u80FD\u4E91\u5B98\u7F51"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'capsule-icon',
    onClick: handleCloudAddressClick,
    "data-track-action": "click",
    "data-track-category": "\u4E91\u5B98\u7F51\u70B9\u51FB",
    "data-track-name": "\u80F6\u56CA-\u4E91\u5B98\u7F51\u70B9\u51FB-pc"
  }, /*#__PURE__*/React.createElement(BdAICloud, {
    fill: "#2468F2"
  }))))), isMobile && (/*#__PURE__*/React.createElement("div", {
    className: 'mobile-capsule',
    ref: capsuleMobileRef
  }, /*#__PURE__*/React.createElement("div", {
    className: 'mobile-capsule-icon',
    onClick: handleCloudAddressClick
  }, /*#__PURE__*/React.createElement(BdAICloud, {
    fill: "#091221"
  })))));
}

export { Capsule as default };
